/** Cross-browser MediaRecorder MIME type (iOS Safari requires webm/opus or mp4). */
export function pickRecorderMimeType() {
  if (typeof MediaRecorder === 'undefined') return '';

  let mimeType = 'audio/webm;codecs=opus';
  if (!MediaRecorder.isTypeSupported(mimeType)) {
    if (MediaRecorder.isTypeSupported('audio/mp4')) {
      mimeType = 'audio/mp4';
    } else if (MediaRecorder.isTypeSupported('audio/webm')) {
      mimeType = 'audio/webm';
    } else {
      mimeType = '';
    }
  }
  return mimeType;
}

export function recorderFilenameForMime(mimeType) {
  const type = (mimeType || '').toLowerCase();
  if (type.includes('mp4') || type.includes('m4a')) return 'recording.m4a';
  if (type.includes('webm')) return 'recording.webm';
  return 'recording.bin';
}
